export default "__VITE_PUBLIC_ASSET__a9c4a103__"